import { TipoFlujoTesoreriaType } from "api/Types/TipoFlujoTesoreria"
import Modal from "common/components/Modal/Modal"
import TesoreriaService from "common/services/TesoreriaService"
import { requestHandler } from "common/utils/utils"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import NewRemesaForm from "../NewRemesaForm"
import NewRemesaInitialForm from "../NewRemesaInitialForm"

interface NewSimpleRemesaModalProps {
  open: boolean
  tipoRemesa?: TipoFlujoTesoreriaType
  handleOpen: (open: boolean) => void
  fetchRemesas: () => void
}

type initialFormPayload = {
  empresaId: string | null
  importe: number | null
}

type principalFormPayload = {
  fechaVencimiento?: string | null
  concepto?: string | null
  cuentaBancariaId?: string | null
  identificador?: string | null
  facturasIds?: string[] | never[] | null
  tipo?: number | null
  tipoFlujoTesoreria?: number | null
}

const initialValuesInitialForm = {
  empresaId: "",
  importe: 0,
}

const NewSimpleRemesaModal = ({
  open = false,
  handleOpen,
  tipoRemesa,
  fetchRemesas,
}: NewSimpleRemesaModalProps) => {
  const { t } = useTranslation()
  const [dataIntialtForm, setDataIntialtForm] = useState<initialFormPayload>(
    initialValuesInitialForm
  )

  const [step, setStep] = useState(0)

  const handleSubmiltIntialForm = (payload: initialFormPayload) => {
    setDataIntialtForm(payload)
    setStep(1)
  }

  const onCloseModal = () => {
    handleOpen(false)
    setStep(0)
    setDataIntialtForm(initialValuesInitialForm)
  }

  const onSubmitSuccess = () => {
    fetchRemesas?.()
    onCloseModal()
  }

  const onSubmit = (payload: principalFormPayload) => {
    const mappedPayload: initialFormPayload & principalFormPayload = {
      ...payload,
      ...dataIntialtForm,
    }
    // @ts-expect-error TS(2554): Expected 7 arguments, but got 4.
    requestHandler(
      mappedPayload,
      TesoreriaService.createSimpleRemesa,
      onSubmitSuccess,
      "La remesa ha sido creada con éxito."
    )
  }

  return (
    <Modal
      header={t("prestamos.form.remesar.newRemittance") ?? undefined}
      visible={open}
      onHide={onCloseModal}
      size='small'
      className={undefined}
      draggable
      keepInViewport={false}
      maskClassName='!tw-z-20'
    >
      {step === 0 && (
        <NewRemesaInitialForm
          hideModal={onCloseModal}
          handleSubmit={handleSubmiltIntialForm}
          t={t}
        />
      )}
      {step === 1 && (
        <NewRemesaForm
          hideModal={onCloseModal}
          onHide={onCloseModal}
          handleCreate={onSubmit}
          data={{ total: dataIntialtForm?.importe, tipo: tipoRemesa }}
          t={t}
        />
      )}
    </Modal>
  )
}

export default NewSimpleRemesaModal
